import { render, staticRenderFns } from "./RawTag.vue?vue&type=template&id=4a596120&scoped=true&"
import script from "./RawTag.vue?vue&type=script&lang=ts&"
export * from "./RawTag.vue?vue&type=script&lang=ts&"
import style0 from "./RawTag.vue?vue&type=style&index=0&id=4a596120&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a596120",
  null
  
)

export default component.exports